import React from 'react'
import { cyberColors } from '../../../../../lib/colors'
import Button from '../../../../elements/button/Button'
import { FlexDiv } from '../../../../elements/NumberInput/NumberInputStyles'
import { SFXS } from '@orbital/games-frontend-library'

interface Action_buttons_props {
  rollUnder: string
  handleAutoConfigs: (b: boolean) => void
  handleStartAuto: (b: boolean) => void
  handleAutoReady: (b: boolean) => void
  handleManual: () => void
  audio: any
  handleSaveConfig: any
}
export default function ActionButtons({
  rollUnder,
  // handleStartAuto,
  handleAutoConfigs,
  handleAutoReady,
  handleManual,
  audio,
  handleSaveConfig,
}: Action_buttons_props) {
  const handleSetAuto = () => {
    handleAutoConfigs(false)
    handleAutoReady(true)
    handleSaveConfig()
  }
  return (
    <FlexDiv>
      <Button
        size='16px'
        background={cyberColors.greyDark}
        height='36px'
        func={() => {
          !audio.isSoundOff && SFXS.goBackSFX.play(), handleManual()
        }}
      >
        <span>BACK TO MANUAL</span>
      </Button>
      <Button
        size='16px'
        background={
          rollUnder == '0' ? cyberColors.redGradient : cyberColors.blueGradient
        }
        height='36px'
        func={() => {
          !audio.isSoundOff && SFXS.goForwardSFX.play(), handleSetAuto()
        }}
      >
        <span>SET AUTOROLL</span>
      </Button>
    </FlexDiv>
  )
}
